"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _material = require("@mui/material");

var _Modal = require("../Modal");

var _Card = require("../Card");

var _Typography = require("../Typography");

var _TextButton = require("../TextButton");

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledCardContent = (0, _material.styled)(_Card.Card.Content)(function (_ref) {
  var theme = _ref.theme;
  return {
    paddingTop: theme.spacing(6)
  };
});
var StyledCardActions = (0, _material.styled)(_Card.Card.Actions)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    padding: theme.spacing(4)
  };
});

var ConfirmationModal = function ConfirmationModal(_ref3) {
  var cancelLabel = _ref3.cancelLabel,
      confirmLabel = _ref3.confirmLabel,
      open = _ref3.open,
      title = _ref3.title,
      subtitle = _ref3.subtitle,
      onClose = _ref3.onClose,
      onConfirm = _ref3.onConfirm,
      ModalProps = _ref3.ModalProps;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal, _objectSpread(_objectSpread({}, ModalProps), {}, {
    onClose: onClose,
    open: open,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.Card, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledCardContent, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.Typography, {
            component: "h1",
            gutterBottom: true,
            variant: "h4",
            children: title
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.Typography, {
            component: "h2",
            children: subtitle
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Divider, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledCardActions, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TextButton.TextButton, {
          label: cancelLabel,
          onClick: onClose,
          variant: "outlined"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextButton.TextButton, {
          label: confirmLabel,
          onClick: onConfirm
        })]
      })]
    })
  }));
};

var _default = ConfirmationModal;
exports.default = _default;